export const LanguageId = {
  VN: 'vi-VN',

  TH: 'th-TH',

  DE: 'de-DE',

  EN: 'en-US',

  KH: 'km-KH',

  LA: 'lo-LA',

  CN: 'zh-CN',
};

export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const RegexValidatePhone = /\d([+(-.\s]?\d{1,}[+)-.\s]?){4,}\d/;

export const RegexValidateEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PasswordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,130}$/;

// Enum ModelState tương ứng với BE
export const ModelState = {
  None: 0,
  Insert: 1,
  Update: 2,
  Delete: 3,
  // cập nhật thông tin employee
  EditInfoEmployee: 4,
  // cập nhật thông tin active của employee
  EditInactive: 5,
  // reset pass
  EditPassword: 6,
};

/**
 * Description: Danh sách quốc gia và mã quốc gia
 * Created by: ndthi
 * Created date: 2025-01-23
 */
export const CountryList = {
  'Germany': 'de',
  'Australia': 'au',
  'Canada': 'ca',
  'New Zealand': 'nz',
  'Turkey': 'tr',
  'United States': 'us',
  'South Africa': 'za',
  'Costa Rica': 'cr',
  'Cuba': 'cu',
  'Spain': 'es',
  'Mexico': 'mx',
  'Switzerland': 'ch',
  'France': 'fr',
  'Greece': 'gr',
  'Hungary': 'hu',
  'Indonesia': 'id',
  'Italy': 'it',
  'Japan': 'jp',
  'Cambodia': 'kh',
  'Korea': 'kr',
  'Laos': 'la',
  'Brunei': 'bn',
  'Malaysia': 'my',
  'Myanmar': 'mm',
  'Nigenia': 'ni',
  'Belgium': 'be',
  'Netherlands': 'nl',
  'Norway': 'no',
  'Poland': 'pl',
  'Slovak Republic': 'sk',
  'Thailand': 'th',
  'Philippines': 'ph',
  'East Timor': 'tp',
  'VietNam': 'vn',
  'China': 'cn',
  'Hong Kong': 'hk',
  'Singapore': 'sg',
  'Taiwan': 'tw'
};

/**
 * Description: Các quốc gia hiển thị thông tin POS, Tablet/Mobile
 * Created by: hbviet
 * Created date: 2025-01-23
 */
export const CountriesWithDeviceList = ['us', 'au', 'ph', 'de'];

/**
 * Description: Các quốc gia hiển thị thông tin POS, Tablet/Mobile
 * Created by: hbviet
 * Created date: 2025-01-23
 */
export const CountriesWithPOSTablet = ['us', 'au', 'ph'];

/**
 * Description: Các quốc gia hiển thị thông tin Kiosk
 * Created by: hbviet
 * Created date: 2025-01-23
 */
export const CountriesWithKiosk = ['us', 'au'];

/**
 * Description: Các quốc gia hiển thị giá trị order
 * @author thlong - 21.07.2026
 */
export const CountriesWithOrderValue = ['us', 'au', 'ph'];

/**
 * Description: Các mã đối tác có giá cả đặc biệt
 * Created by: hbviet
 * Created date: 01/08/2025
 */
export const CustomPricingPartnerCodes = ['P-6398', 'P-2903', 'P-4973'];
/**
 * Description: Các mã đối tác không thu phí khởi tạo kiosk
 * Created by: hbviet
 * Created date: 01/08/2025
 */
export const NoKioskPricePartnerCodes = ['P-6398', 'P-2903', 'P-4973'];
